/**
 * Small formatting helpers shared by label job builders.
 * Kept dependency-free so tests stay fast and templates stay pure.
 */

/** Format a date for label output (matches on-screen spare-part labels). */
export function formatLabelDate(dateStr?: string | Date | null, locale = "en-GB"): string {
  if (!dateStr) return "—";
  const d = dateStr instanceof Date ? dateStr : new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "—";
  const parts = new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).formatToParts(d);
  const day = parts.find((p) => p.type === "day")?.value ?? "";
  const month = parts.find((p) => p.type === "month")?.value.replace(".", "") ?? "";
  const year = parts.find((p) => p.type === "year")?.value ?? "";
  return `${day} ${month}, ${year}`;
}

export function formatSourced(brand?: string | null, model?: string | null): string {
  return [brand, model].filter(Boolean).join(" ") || "—";
}

export function truncate(value: string | undefined | null, max: number): string {
  const s = (value ?? "").toString();
  if (s.length <= max) return s;
  return `${s.slice(0, Math.max(0, max - 1))}…`;
}
